import { render, staticRenderFns } from "./JourneyLayout.vue?vue&type=template&id=41d16057"
import script from "./JourneyLayout.vue?vue&type=script&lang=js"
export * from "./JourneyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports